<template>
  <div v-if="attachmentList.length" class="section">
    <div class="section-title">
      <base-section-title title="澄清文件" />
    </div>
    <div class="section-content w-800">
      <el-collapse v-model="activeNames">
        <el-collapse-item
          v-for="(item, index) in attachmentList"
          :key="index"
          :name="`${index}`"
        >
          <template slot="title">
            <div class="file-title">
              <div>
                <span class="text-warning clarify-num">
                  第{{ Number(attachmentList.length) - Number(index) }}次澄清
                </span>
                <span class="text-bold">
                  发布时间：{{ item.supplementTime }}
                </span>
              </div>
              <div>
                <el-button
                  type="text"
                  class="m-l-20"
                  @click.stop="openNotice(item)"
                >
                  查看澄清说明
                </el-button>
                <el-button
                  v-if="!isSupplier"
                  type="text"
                  class="m-l-20"
                  @click.stop="openStatisticsDialog(item)"
                >
                  答疑澄清查阅统计
                </el-button>
              </div>
            </div>
          </template>
          <el-form
            class="m-t-10 detail-form"
            label-suffix="："
            label-width="140px"
          >
            <el-form-item label="澄清文件">
              <upload-authorization-file
                v-if="item.fileGroupId"
                ref="UploadAuthorizationFile"
                v-model="item.fileGroupId"
                style="width:500px"
                :preview-api="previewApi"
                :download-api="downloadApi"
                :props-data="{
                  disabled: true
                }"
                :request-params="{
                  isRelease: true,
                  orderId: orderId,
                  tradeId: tradeId,
                  fileType: fileTypeDict.CLARIFY.value,
                  fileGroupId: item.fileGroupId,
                  supplementId: item.supplementId
                }"
              />
              <span v-else>-</span>
            </el-form-item>
            <el-divider v-if="item.biddingFileId" />
            <el-form-item v-if="item.biddingFileId" label="电子招标文件">
              <el-button class="p-0" type="text" @click="toBidFileDetail(item)">
                查看详情
              </el-button>
            </el-form-item>
          </el-form>
        </el-collapse-item>
      </el-collapse>
    </div>

    <!----公告------>
    <bulletin-dialog
      :visible.sync="visible"
      title="澄清文件说明"
      :content="content"
    />

    <!----澄清统计弹窗------>
    <el-dialog
      title="答疑澄清查阅统计"
      :visible.sync="showDialog"
      :close-on-click-modal="false"
      :before-close="closeDialog"
      class="dialog"
      width="800px"
    >
      <el-input
        v-model="supplierName"
        class="search-input-inbox"
        placeholder="请输入供应商名称"
        clearable
      >
        <template slot="append">
          <el-button type="primary" @click="searchStatistics()">
            搜索
          </el-button>
        </template>
      </el-input>
      <div class="m-t-10 m-b-10 text-info">
        供应商查看澄清说明或下载或预览澄清文件都算已查阅
      </div>
      <jczh-table-content
        border
        class="m-t-10"
        :data="listData"
        :option="listOptions"
        pagination
        :page.sync="page"
        :limit.sync="size"
        :total="total"
        :pagination-props="{
          pageSizes: [5, 10, 20, 30]
        }"
        @pagination="searchStatistics()"
      >
        <template v-slot:viewerList="{ row }">
          <template v-if="row.viewerList && row.viewerList.length">
            <div v-for="item in row.viewerList" :key="item.viewEmployeeId">
              {{ item.viewEmployeeName }}
              <span class="text-info">({{ item.viewTime }})</span>
            </div>
          </template>
          <span v-else>-</span>
        </template>
      </jczh-table-content>
    </el-dialog>
  </div>
</template>

<script>
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import BulletinDialog from '@/components/common/Bulletins/BulletinDialog'
import UploadAuthorizationFile from '@/components/common/Upload/UploadAuthorizationFile'

import { getClarifyViewLogsApi } from '@/api/procure/invite-bid'
import { supplierClarifiedViewApi } from '@/api/supplier/bid'

import { fileTypeDict } from '@/dictionary/project/bid'
import { getBidFileClarifyLogApi } from '@/api/project-view/bidding'

export default {
  components: {
    BaseSectionTitle,
    BulletinDialog,
    UploadAuthorizationFile
  },

  props: {
    orderId: {
      type: [Number, String],
      default: ''
    },
    tradeId: {
      type: [Number, String],
      default: ''
    },
    isSupplier: {
      type: Boolean,
      default: false
    },
    attachmentList: {
      type: Array,
      default: () => []
    },
    previewApi: {
      type: Function,
      default: () => {}
    },
    downloadApi: {
      type: Function,
      default: () => {}
    },

    // 是否是在查询统计中使用
    isStatistics: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      fileTypeDict,

      visible: false,
      activeNames: ['0'],
      content: '',

      // 统计列表
      showDialog: false,
      supplementId: '',
      supplierName: '',
      page: 1,
      size: 5,
      total: 0,
      listData: [],
      listOptions: [
        { label: '供应商名称', prop: 'supplierName', minWidth: 100 },
        {
          label: '联系方式',
          prop: '',
          minWidth: 140,
          filter: value => {
            return `${value.contactUserName} ${value.contactUserPhone}`
          }
        },
        {
          label: '查阅状态',
          prop: 'viewed',
          minWidth: 100,
          filter: value => (value ? '已查阅' : '未查阅')
        },
        {
          label: '查阅人员(最早查阅时间)',
          prop: '',
          slotName: 'viewerList',
          minWidth: 200
        }
      ]
    }
  },

  computed: {
    // 路由前缀
    routerPrefix() {
      const firstWord = (
        this.$route.name?.replace(/([A-Z])/g, $0 => `-${$0}`)?.split('-') || []
      ).filter(v => v)[0]

      if (firstWord === 'Bidding') return ''
      else return firstWord || ''
    }
  },

  methods: {
    /**
     * 打开公告
     * 供应商端需要触发查阅澄清文件日志接口
     */
    async openNotice(row) {
      if (this.isSupplier) {
        this.viewClarified(row)
      } else {
        this.content = row.supplementRemark
        this.visible = true
      }
    },

    /**
     * 触发查阅澄清文件日志接口
     */
    async viewClarified(row) {
      try {
        await supplierClarifiedViewApi(
          this.orderId,
          this.tradeId,
          row.supplementId
        )
        this.content = row.supplementRemark
        this.visible = true
      } catch (error) {
        this.$message.error(error.message)
      }
    },

    /**
     * 查看澄清后的电子标书详情
     */
    toBidFileDetail(item) {
      if (this.$route.path.includes('supplier')) {
        this.$router.push({
          name: 'SupplierKpbBidFileDetail',
          params: {
            orderId: this.orderId,
            tradeId: this.tradeId,
            biddingFileId: item.biddingFileId,
            supplementId: item.supplementId
          }
        })
      } else {
        this.$router.push({
          name: this.routerPrefix + 'BiddingFileInfo',
          params: {
            orderId: this.orderId,
            biddingFileId: item.biddingFileId,
            supplementId: item.supplementId
          }
        })
      }
    },

    /**
     * 打开答疑澄清查阅统计弹窗
     */
    openStatisticsDialog(row) {
      this.showDialog = true
      this.supplementId = row.supplementId
      this.searchStatistics()
    },

    /**
     * 关闭弹窗
     */
    closeDialog() {
      this.page = 1
      this.size = 5
      this.supplierName = ''
      this.showDialog = false
    },

    /**
     * 查询澄清查阅统计
     */
    async searchStatistics() {
      try {
        const queryApi = this.isStatistics
          ? getBidFileClarifyLogApi
          : getClarifyViewLogsApi
        const _data = await queryApi(
          {
            supplementId: this.supplementId,
            supplierName: this.supplierName,
            page: this.page,
            size: this.size
          },
          this.orderId
        )
        this.listData = _data.data?.records || []
        this.total = _data.data?.total || 0
      } catch (error) {
        this.$message.error(error.message)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.w-800 {
  width: 800px;
}
.file-title {
  width: 100%;
  color: $text-color;
  font-weight: normal;
  font-size: pixel-to-rem($n: 19);
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1 0 90%;
  order: 1;
  .clarify-num {
    border: 1px solid $warning-color;
    font-size: 12px;
    border-radius: 2px;
    padding: 2px 6px;
    margin-right: 4px;
  }
}
::v-deep {
  .el-collapse {
    border: none;
  }
  .el-collapse-item__header {
    background-color: $grey-background-color;
    flex: 1 0 auto;
    line-height: 1;
    margin-top: 10px;
    padding: 10px 16px;
    height: 34px;
  }
  .el-collapse-item__wrap {
    border-bottom: none;
    background-color: $grey-background-color;
  }
  .el-collapse-item__content {
    padding-bottom: 5px;
  }
  .el-divider {
    background-color: $dividing-color;
  }
  .el-divider--horizontal {
    width: 90%;
    margin: 10px auto;
  }
}

.search-input-inbox {
  width: 400px;
  border: none;
}
::v-deep {
  .el-input-group__append,
  .el-input-group__prepend {
    color: #fff;
  }
  .el-icon-arrow-right:before {
    content: '\e791';
  }
}
</style>
